(function (window, document) {
  "use strict";

  var DNB = window.DNB;

  window.addEventListener("load", function () {
    if (DNB && DNB.ScrollService) {
      DNB.ScrollService.init();
    }
  });
})(window, document);
